import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BaseIconComponent } from '../base-icon.component'

@Component({
  selector: 'app-icon-case',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 4H14.425C14.2509 3.15356 13.7904 2.39301 13.1209 1.84654C12.4515 1.30007 11.6142 1.00109 10.75 1L9.25 1C8.38585 1.00109 7.54849 1.30007 6.87906 1.84654C6.20964 2.39301 5.74907 3.15356 5.575 4H4.75C3.7558 4.00119 2.80267 4.39666 2.09966 5.09966C1.39666 5.80267 1.00119 6.7558 1 7.75L1 15.25C1.00119 16.2442 1.39666 17.1973 2.09966 17.9003C2.80267 18.6033 3.7558 18.9988 4.75 19H15.25C16.2442 18.9988 17.1973 18.6033 17.9003 17.9003C18.6033 17.1973 18.9988 16.2442 19 15.25V7.75C18.9988 6.7558 18.6033 5.80267 17.9003 5.09966C17.1973 4.39666 16.2442 4.00119 15.25 4ZM9.25 2.5H10.75C11.2137 2.50192 11.6655 2.64706 12.0435 2.91557C12.4216 3.18407 12.7074 3.56282 12.862 4H7.138C7.29256 3.56282 7.57842 3.18407 7.95648 2.91557C8.33453 2.64706 8.7863 2.50192 9.25 2.5ZM4.75 5.5H15.25C15.8467 5.5 16.419 5.73705 16.841 6.15901C17.2629 6.58097 17.5 7.15326 17.5 7.75V10H2.5V7.75C2.5 7.15326 2.73705 6.58097 3.15901 6.15901C3.58097 5.73705 4.15326 5.5 4.75 5.5ZM15.25 17.5H4.75C4.15326 17.5 3.58097 17.2629 3.15901 16.841C2.73705 16.419 2.5 15.8467 2.5 15.25V11.5H9.25V12.25C9.25 12.4489 9.32902 12.6397 9.46967 12.7803C9.61032 12.921 9.80109 13 10 13C10.1989 13 10.3897 12.921 10.5303 12.7803C10.671 12.6397 10.75 12.4489 10.75 12.25V11.5H17.5V15.25C17.5 15.8467 17.2629 16.419 16.841 16.841C16.419 17.2629 15.8467 17.5 15.25 17.5Z"
        [attr.fill]="color"
        style="fill-opacity:1;"
      />
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseIconComponent extends BaseIconComponent {}
